export let wordlist = {

"the open digital wine ecosystem": {
  "en": "the digital open wine ecosystem",
  "fr": "l'écosystème numérique ouvert du vin",
  "de": "das offene digitale Weinökosystem",
  "es": "el ecosistema digital abierto del vino",
  "it": "l'ecosistema digitale aperto del vino",
  "nl": "het open digitale wijnecosysteem",
  "pt": "o ecossistema digital aberto do vinho"
},

"funware for wine lovers developed and © copyrighted by N'JOY Information Technology": {
  "en": "funware for wine lovers developed and ©c opyrighted by N'JOY Information Technology",
  "fr": "funware pour les amateurs de vin, développé et © protégé par le droit d'auteur par N'JOY Information Technology",
  "de": "Funware für Weinliebhaber, entwickelt und ©u rheberrechtlich geschützt von N'JOY Information Technology",
  "es": "funware para los amantes del vino, desarrollado y © protegido por derechos de autor por N'JOY Information Technology",
  "it": "funware per gli amanti del vino, sviluppato e © protetto da copyright da N'JOY Information Technology",
  "nl": "funware voor wijnliefhebbers, ontwikkeld en © auteursrechtelijk beschermd door N'JOY Information Technology",
  "pt": "funware para os amantes do vinho, desenvolvido e © protegido por direitos de autor pela N'JOY Information Technology"
},

"funware for wine lovers developed and © copyrighted by": {
  "en": "funware for wine lovers developed and ©c opyrighted by",
  "fr": "funware pour les amateurs de vin, développé et © protégé par le droit d'auteur par",
  "de": "Funware für Weinliebhaber, entwickelt und ©u rheberrechtlich geschützt von",
  "es": "funware para los amantes del vino, desarrollado y © protegido por derechos de autor por",
  "it": "funware per gli amanti del vino, sviluppato e © protetto da copyright da",
  "nl": "funware voor wijnliefhebbers, ontwikkeld en © auteursrechtelijk beschermd door",
  "pt": "funware para os amantes do vinho, desenvolvido e © protegido por direitos de autor pela"
},


"who we are, what we do":{
  "en": "who we are, what we do",
  "fr": "qui sommes-nous, que faisons-nous",
  "de": "wer wir sind, was wir tun",
  "es": "quiénes somos, qué hacemos",
  "it": "chi siamo, cosa facciamo",
  "nl": "wie we zijn, wat we doen",
  "pt": "quem somos, o que fazemos"
},

"for wine producers":{
  "en": "for wine producers",
  "fr": "pour les producteurs de vin",
  "de": "für Weinproduzenten",
  "es": "para los productores de vino",
  "it": "per i produttori di vino",
  "nl": "voor wijnproducenten",
  "pt": "para os produtores de vinho"
},

"for wine collectors":{
  "en": "for wine collectors",
  "fr": "pour les collectionneurs de vin",
  "de": "für Weinsammler",
  "es": "para coleccionistas de vino",
  "it": "per i collezionisti di vino",
  "nl": "voor wijnverzamelaars",
  "pt": "para colecionadores de vinho"
},

"for wine tasting events":{
  "en": "for wine tasting events",
  "fr": "pour les dégustations de vin",
  "de": "für Weinverkostungen",
  "es": "para las catas de vino",
  "it": "per le degustazioni di vino",
  "nl": "voor wijnproeverijen",
  "pt": "para provas de vinho"
},

}

export function translate_word(string, language) {
    let local_debug = false
    if (local_debug) console.log("original:", string)
    if (wordlist[string] && wordlist[string][language]) {
        if (local_debug) console.log("translation:", wordlist[string][language])
        return wordlist[string][language];
    } else {
        if (local_debug) console.log("translation:", string)
        return string;
    }
}